module.exports = __webpack_public_path__ + "static/media/spritesheet.26953af5.png";